import { useEffect } from "react";

export const useDocumentTitle = (title: string) => {

    useEffect(() => {
        document.title = `${title} - Oso Electric Lawn Equipment App`;
    }, [title]);

    return null;
}